module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base"
  }, [_c('promotions'), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__container"
  }, [_c('div', {
    staticClass: "knowledge-base__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--head"
  }, [_c('h1', [_vm._v("The Clear Assured inclusion hub")]), _vm._v(" "), _c('p', [_vm._v("\n          Find the subject you're interested in by searching a keyword, browsing resources by categories and topics.\n          If there is anything you'd like to read about, but can't find in our inclusion hub "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(" and share your ideas with us, we'd be happy to add more content that's of interest.\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__control"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__control--icon",
    class: {
      'active': _vm.searchKey
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16.031",
      "height": "16.031",
      "viewBox": "0 0 16.031 16.031"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15.781,0a.689.689,0,0,1,0,1.063l-.719.719a.689.689,0,0,1-1.062,0L10.125-2.094A6.348,6.348,0,0,1,6.5-1,6.261,6.261,0,0,1,1.906-2.906,6.261,6.261,0,0,1,0-7.5a6.261,6.261,0,0,1,1.906-4.594A6.261,6.261,0,0,1,6.5-14a6.261,6.261,0,0,1,4.594,1.906A6.261,6.261,0,0,1,13-7.5a6.348,6.348,0,0,1-1.094,3.625ZM3.672-10.328A3.854,3.854,0,0,0,2.5-7.5,3.854,3.854,0,0,0,3.672-4.672,3.854,3.854,0,0,0,6.5-3.5,3.854,3.854,0,0,0,9.328-4.672,3.854,3.854,0,0,0,10.5-7.5a3.854,3.854,0,0,0-1.172-2.828A3.854,3.854,0,0,0,6.5-11.5,3.854,3.854,0,0,0,3.672-10.328Z",
      "transform": "translate(0 14)"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchKey),
      expression: "searchKey",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "knowledgeSearch",
      "placeholder": "Search resource...",
      "aria-label": "Search resource"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value.trim()
      }, function($event) {
        return _vm.search()
      }],
      "keydown": function($event) {
        return _vm.keyDownPressed($event)
      },
      "blur": [function($event) {
        return _vm.searchLeave($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), (_vm.searchKey) ? _c('button', {
    staticClass: "knowledge-base__content--search__control--reset",
    attrs: {
      "aria-label": "Reset search"
    },
    on: {
      "click": function($event) {
        return _vm.searchReset()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "11.188",
      "height": "11.188",
      "viewBox": "0 0 11.188 11.188"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M8.125,8l3.188,3.188a1.02,1.02,0,0,1,0,1.406l-.719.719a1.02,1.02,0,0,1-1.406,0L6,10.125,2.813,13.313a.954.954,0,0,1-.7.281.954.954,0,0,1-.7-.281l-.719-.719a1.02,1.02,0,0,1,0-1.406L3.875,8,.688,4.813a.954.954,0,0,1-.281-.7.954.954,0,0,1,.281-.7l.719-.719a.954.954,0,0,1,.7-.281.954.954,0,0,1,.7.281L6,5.875,9.188,2.688a1.02,1.02,0,0,1,1.406,0l.719.719a.954.954,0,0,1,.281.7.954.954,0,0,1-.281.7Z",
      "transform": "translate(-0.406 -2.406)"
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.searchKey || (_vm.searchCategories && _vm.searchCategories.length) || (_vm.searchTopics && _vm.searchTopics.length) || (_vm.searchTypes && _vm.searchTypes.length)) ? [_c('div', {
    staticClass: "knowledge-base__content--search__filters"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__filters--selectors"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "categories-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Category name...",
      "options": _vm.getNonEmptyCategoriesForSelect,
      "data-lpignore": "true",
      "inputId": "searchCategories"
    },
    model: {
      value: (_vm.searchCategories),
      callback: function($$v) {
        _vm.searchCategories = $$v
      },
      expression: "searchCategories"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchCategories'
    }
  }, [_c('i', {
    staticClass: "fas fa-sitemap"
  }), _vm._v(" "), _c('span', [_vm._v("\n                  Filter by Category "), (_vm.searchCategories && _vm.searchCategories.length) ? [_vm._v("(" + _vm._s(_vm.searchCategories.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.searchCategories && _vm.searchCategories.length) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.searchCategories = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "topics-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Topic name...",
      "options": _vm.getNonEmptyTagsForSelect,
      "data-lpignore": "true",
      "inputId": "searchTopics"
    },
    model: {
      value: (_vm.searchTopics),
      callback: function($$v) {
        _vm.searchTopics = $$v
      },
      expression: "searchTopics"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchTopics'
    }
  }, [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Filter by Topic "), (_vm.searchTopics && _vm.searchTopics.length) ? [_vm._v("(" + _vm._s(_vm.searchTopics.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), (_vm.searchTopics && _vm.searchTopics.length) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.searchTopics = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--selector"
  }, [_c('filters-select', {
    staticClass: "types-selector",
    attrs: {
      "searchable": true,
      "multiple": true,
      "closeOnSelect": false,
      "clearSearchOnSelect": false,
      "clearSearchOnBlur": true,
      "placeholder": "Type Type name...",
      "options": _vm.getContentTypeForSelect,
      "data-lpignore": "true",
      "inputId": "searchTypes"
    },
    model: {
      value: (_vm.searchTypes),
      callback: function($$v) {
        _vm.searchTypes = $$v
      },
      expression: "searchTypes"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'searchTypes'
    }
  }, [_c('i', {
    staticClass: "fas fa-shapes"
  }), _vm._v(" "), _c('span', [_vm._v("Filter by Type "), (_vm.searchTypes && _vm.searchTypes.length) ? [_vm._v("(" + _vm._s(_vm.searchTypes.length) + ")")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset"
  }, [(_vm.searchTypes && _vm.searchTypes.length) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.searchTypes = []
      }
    }
  }, [_c('span', [_vm._v("Clear Category filters")])]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__filters--actions"
  }, [((_vm.searchCategories && _vm.searchCategories.length) || (_vm.searchTopics && _vm.searchTopics.length) || (_vm.searchTypes && _vm.searchTypes.length)) ? _c('div', {
    staticClass: "knowledge-base__content--search__filters--reset reset-all"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.resetAllFilters()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-filter"
  }), _c('span', [_vm._v("Clear all filters")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results"
  }, [(!_vm.loadingResources) ? [(_vm.results && _vm.results.length > 0) ? _vm._l((_vm.results), function(result) {
    return _c('router-link', {
      key: result.id,
      staticClass: "knowledge-base__content--search__result",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: result.id
          }
        },
        "aria-label": result.title
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--search__result--title"
    }, [(result.content_type.id === 7) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "21",
        "height": "21",
        "viewBox": "0 0 21 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
        "transform": "translate(-7.281 -7.281)"
      }
    })])]) : (result.content_type.id === 8) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.746",
        "height": "21.004",
        "viewBox": "0 0 15.746 21.004"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
        "transform": "translate(-9.25 -6.996)"
      }
    })])]) : (result.content_type.id === 9) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.75",
        "height": "21",
        "viewBox": "0 0 15.75 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
        "transform": "translate(-9.25 -7)"
      }
    })])]) : (result.content_type.id === 10) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "23.627",
        "height": "21",
        "viewBox": "0 0 23.627 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
        "transform": "translate(-20213 8609.998)"
      }
    })])]) : (result.content_type.id === 11) ? _c('div', {
      staticClass: "knowledge-base__content--search__result--icon",
      class: 'type__' + result.content_type.id
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "18.53",
        "height": "22.876",
        "viewBox": "0 0 18.53 22.876"
      }
    }, [_c('g', {
      attrs: {
        "transform": "translate(-8 -6.124)"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
        "transform": "translate(0.517 1.307)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
        "transform": "translate(0.526 1.772)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
        "transform": "translate(1.21 1.803)"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHighLightedResult(result.title))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "knowledge-base__content--search__result--text",
      domProps: {
        "innerHTML": _vm._s(_vm.getHighLightedResult(result.content))
      }
    })])
  }) : [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty__icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "22.5",
      "height": "30",
      "viewBox": "0 0 22.5 30"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15-26.25v7.5h7.5ZM10.313-11.719A3.285,3.285,0,0,0,7.031-8.437a3.285,3.285,0,0,0,3.281,3.281,3.285,3.285,0,0,0,3.281-3.281A3.285,3.285,0,0,0,10.313-11.719Zm2.813-7.031v-7.5H2.813A2.813,2.813,0,0,0,0-23.437V.938A2.813,2.813,0,0,0,2.813,3.75H19.688A2.813,2.813,0,0,0,22.5.938V-16.875H15A1.875,1.875,0,0,1,13.125-18.75Zm5.35,16.487a.937.937,0,0,1,0,1.326l-.663.663a.937.937,0,0,1-1.326,0L13.433-3.229a6.036,6.036,0,0,1-3.12.885A6.094,6.094,0,0,1,4.219-8.437a6.094,6.094,0,0,1,6.094-6.094,6.094,6.094,0,0,1,6.094,6.094,6.048,6.048,0,0,1-.955,3.249Z",
      "transform": "translate(0 26.25)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results--empty__text"
  }, [_vm._v("\n                  No results found. Try again.\n                ")])])]] : [_vm._m(0)]], 2), _vm._v(" "), (_vm.results && _vm.results.length > 0) ? _c('div', {
    staticClass: "knowledge-base__content--search__load-more"
  }, [_c('span', [_vm._v("Showing " + _vm._s(_vm.results.length) + " resources")]), _vm._v(" "), (_vm.moreResults) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._v("Load more resources")]) : _vm._e()]) : _vm._e()] : [_c('div', {
    staticClass: "knowledge-base__content--categories"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category__title"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "16",
      "viewBox": "0 0 20 16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M4-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,5-2V1A.963.963,0,0,1,4,2H1A.963.963,0,0,1,0,1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,1-3ZM3.25-5.5V-4H1.75V-5.812a1.147,1.147,0,0,1,.344-.844A1.147,1.147,0,0,1,2.938-7H9.25V-9H8a.973.973,0,0,1-.719-.281A.973.973,0,0,1,7-10v-3a.973.973,0,0,1,.281-.719A.973.973,0,0,1,8-14h4a.973.973,0,0,1,.719.281A.973.973,0,0,1,13-13v3a.973.973,0,0,1-.281.719A.973.973,0,0,1,12-9H10.75v2h6.313a1.147,1.147,0,0,1,.844.344,1.147,1.147,0,0,1,.344.844V-4h-1.5V-5.5h-6V-4H9.25V-5.5ZM11.5-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,12.5-2V1a.963.963,0,0,1-1,1h-3a.963.963,0,0,1-1-1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,8.5-3ZM19-3a.973.973,0,0,1,.719.281A.973.973,0,0,1,20-2V1a.963.963,0,0,1-1,1H16a.963.963,0,0,1-1-1V-2a.973.973,0,0,1,.281-.719A.973.973,0,0,1,16-3Z",
      "transform": "translate(0 14)"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Browse by Categories")])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category__items"
  }, _vm._l((_vm.articleCategories), function(category) {
    return _c('a', {
      staticClass: "knowledge-base__content--category__item",
      attrs: {
        "aria-label": category.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(category, 'searchCategories')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--category__item--title"
    }, [(category.icon) ? _c('div', {
      staticClass: "knowledge-base__content--category__item--icon",
      domProps: {
        "innerHTML": _vm._s(category.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(category.title))])]), _vm._v(" "), (category.description && category.description !== '') ? _c('div', {
      staticClass: "knowledge-base__content--category__item--text"
    }, [_vm._v(_vm._s(category.description))]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category"
  }, [_c('div', {
    staticClass: "knowledge-base__content--category__title"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M0-12.125a.838.838,0,0,1,.266-.609A.838.838,0,0,1,.875-13H6.719a1.658,1.658,0,0,1,1.219.5L13.5-6.937A1.658,1.658,0,0,1,14-5.719a1.764,1.764,0,0,1-.5,1.25L8.531.5a1.764,1.764,0,0,1-1.25.5A1.658,1.658,0,0,1,6.063.5L.5-5.062A1.658,1.658,0,0,1,0-6.281Zm2.781,1.906A.973.973,0,0,0,2.5-9.5a.973.973,0,0,0,.281.719A.973.973,0,0,0,3.5-8.5a.973.973,0,0,0,.719-.281A.973.973,0,0,0,4.5-9.5a.973.973,0,0,0-.281-.719A.973.973,0,0,0,3.5-10.5.973.973,0,0,0,2.781-10.219Z",
      "transform": "translate(0 13)"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Browse by Topics")])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--category__items"
  }, _vm._l((_vm.articleTopics.slice(0, 4)), function(topic) {
    return _c('a', {
      staticClass: "knowledge-base__content--category__item",
      attrs: {
        "aria-label": topic.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(topic, 'searchTopics')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--category__item--title"
    }, [(topic.icon) ? _c('div', {
      staticClass: "knowledge-base__content--category__item--icon topic-icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(topic.title))])]), _vm._v(" "), (topic.description && topic.description !== '') ? _c('div', {
      staticClass: "knowledge-base__content--category__item--text"
    }, [_vm._v(_vm._s(topic.description))]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__all"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__items"
  }, _vm._l((_vm.articleTopics), function(topic) {
    return _c('a', {
      staticClass: "knowledge-base__content--topics__item",
      attrs: {
        "aria-label": topic.title
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activateFilter(topic, 'searchTopics')
        }
      }
    }, [_c('div', {
      staticClass: "knowledge-base__content--topics__item--title"
    }, [(topic.icon) ? _c('div', {
      staticClass: "knowledge-base__content--topics__item--icon topic-icon",
      domProps: {
        "innerHTML": _vm._s(topic.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(topic.title))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__suggest"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--topics__content"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__suggest--container"
  }, [_c('div', {
    staticClass: "knowledge-base__content--topics__suggest--text"
  }, [_vm._v("\n                  We are permanently looking to enrich the inclusion hub. If you'd like to read resources on other topics, share with us what topics you are interested in and we'll do our best to cover those subjects.\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "knowledge-base__content--topics__suggest--button",
    on: {
      "click": function($event) {
        return _vm.activateTopicSuggestion()
      }
    }
  }, [_vm._v("\n                  Suggest topic\n                ")])])])])])]], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--search__results--empty"
  }, [_c('div', {
    staticClass: "knowledge-base__content--search__results--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "knowledge-base__content--search__results--empty__text"
  }, [_vm._v("\n                Loading search results\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--topics__title"
  }, [_c('h2', [_vm._v("All topics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-base__content--topics__title"
  }, [_c('h2', [_vm._v("Suggest us a new topic!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-624687cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/KnowledgeBase.vue
// module id = 1012
// module chunks = 0